module.exports = __webpack_public_path__ + "static/media/riverSketch2.66c5167e.png";